
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import MissionSection from './components/MissionSection';
import ImplantationsSection from './components/ImplantationsSection';
import GallerySection from './components/GallerySection';

export default function AboutPage() {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <IntroSection />
      <MissionSection />
      <ImplantationsSection />
      <GallerySection />
    </div>
  );
}